import { Helpers } from '../../helpers';
import { IDefaultProjectTeam } from '../../interfaces/idefault-project-team';
import { AssetTeam } from '../asset-team';
import { Employee } from '../employee';
import { Project } from '../project';
import { TeamRole } from '../team-role';

export class DefaultProjectTeamBase {
  DefaultProjectTeamId: number;
  Description: string | null;
  AssetTeamId: number | null;
  ProgramManagerEmployeeId: number | null;
  ProgramManagerTeamRoleId: number | null;
  ProjectManagerEmployeeId: number | null;
  ProjectManagerTeamRoleId: number | null;
  ProjectControlAnalystEmployeeId: number | null;
  ProjectControlAnalystTeamRoleId: number | null;
  ProjectEngineerEmployeeId: number | null;
  ProjectEngineerTeamRoleId: number | null;
  ProjectTechEmployeeId: number | null;
  ProjectTechTeamRoleId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Projects_DefaultProjectTeam?: Array<Project> | null;
  AssetTeam?: AssetTeam;
  ProgramManagerEmployee?: Employee;
  ProgramManagerTeamRole?: TeamRole;
  ProjectControlAnalystEmployee?: Employee;
  ProjectControlAnalystTeamRole?: TeamRole;
  ProjectEngineerEmployee?: Employee;
  ProjectEngineerTeamRole?: TeamRole;
  ProjectManagerEmployee?: Employee;
  ProjectManagerTeamRole?: TeamRole;
  ProjectTechEmployee?: Employee;
  ProjectTechTeamRole?: TeamRole;

  constructor(item?: IDefaultProjectTeam) {
    if (item) {

      this.DefaultProjectTeamId = item.DefaultProjectTeamId;
      this.Description = item.Description;
      this.AssetTeamId = item.AssetTeamId;
      this.ProgramManagerEmployeeId = item.ProgramManagerEmployeeId;
      this.ProgramManagerTeamRoleId = item.ProgramManagerTeamRoleId;
      this.ProjectManagerEmployeeId = item.ProjectManagerEmployeeId;
      this.ProjectManagerTeamRoleId = item.ProjectManagerTeamRoleId;
      this.ProjectControlAnalystEmployeeId = item.ProjectControlAnalystEmployeeId;
      this.ProjectControlAnalystTeamRoleId = item.ProjectControlAnalystTeamRoleId;
      this.ProjectEngineerEmployeeId = item.ProjectEngineerEmployeeId;
      this.ProjectEngineerTeamRoleId = item.ProjectEngineerTeamRoleId;
      this.ProjectTechEmployeeId = item.ProjectTechEmployeeId;
      this.ProjectTechTeamRoleId = item.ProjectTechTeamRoleId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Projects_DefaultProjectTeam = Helpers.createClassArray(Project, item.Projects_DefaultProjectTeam);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.ProgramManagerEmployee = new Employee(item.ProgramManagerEmployee);
      this.ProgramManagerTeamRole = new TeamRole(item.ProgramManagerTeamRole);
      this.ProjectControlAnalystEmployee = new Employee(item.ProjectControlAnalystEmployee);
      this.ProjectControlAnalystTeamRole = new TeamRole(item.ProjectControlAnalystTeamRole);
      this.ProjectEngineerEmployee = new Employee(item.ProjectEngineerEmployee);
      this.ProjectEngineerTeamRole = new TeamRole(item.ProjectEngineerTeamRole);
      this.ProjectManagerEmployee = new Employee(item.ProjectManagerEmployee);
      this.ProjectManagerTeamRole = new TeamRole(item.ProjectManagerTeamRole);
      this.ProjectTechEmployee = new Employee(item.ProjectTechEmployee);
      this.ProjectTechTeamRole = new TeamRole(item.ProjectTechTeamRole);
    }
  }
}